/**
 * Program Cards 1070 — KUK "Explore other courses".
 *
 * The band that closes every programme page: an eyebrow line over a heading, then the
 * other programmes as a four-up image-card grid from 768px up and a horizontal rail
 * below it. Ported from kuk-campus-portal `components/Degree/Explore.tsx`.
 *
 * Every field maps to a column that already exists on `program_cards` — the variant
 * adds no schema of its own beyond widening `program_cards.variant`.
 */

export const PROGRAM_CARDS_1070_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Programme cards",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_parent_title: "",
    meta_title: "",
    meta_sub_title: "",
    meta_image: "",
    meta_alt_image: "",
    meta_url: "",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_CARDS_FIELDS_CONFIG: [
    {
      fieldName: "pre_title",
      label: "Eyebrow line",
      value: "Didn't find what you need?",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Didn't find what you need?",
    },
    {
      fieldName: "pre_title_color",
      label: "Eyebrow colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#101112",
    },
    {
      fieldName: "title",
      label: "Heading",
      value: "Explore other courses",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Explore other courses",
    },
    {
      fieldName: "title_text_color",
      label: "Heading + card title colour",
      value: "#101112",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#101112",
    },
    {
      fieldName: "gradient_color_1",
      label: "Heading rule colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#9F1C33",
      description: "The short accent bar under the heading.",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "background_image",
      label: "Band artwork",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload full-bleed background",
      description: "Stretched to fill the band, as in the reference.",
      defaultValue: "",
      filterCategory: "images",
    },
    {
      fieldName: "desktop_background_color",
      label: "Band fill (behind the artwork)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "card_background_color",
      label: "Card surface",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "salary_text_color",
      label: "Card second-line colour",
      value: "#4A5568",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#4A5568",
    },
    {
      fieldName: "cta_text",
      label: "Card CTA text",
      value: "View",
      valueType: "string",
      filedType: "INPUT",
      description: "Blank hides the button.",
      defaultValue: "View",
    },
    {
      fieldName: "cta_text_color",
      label: "Card CTA label colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "cta_background_start_color",
      label: "Card CTA fill",
      value: "#F7F7F7",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#F7F7F7",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Card image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      defaultValue: "",
    },
    {
      header: "Image alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Parent programme (set to render as a specialisation)",
      fieldName: "meta_parent_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Master of Arts",
      description: "Set → the card leads with this and prints \"Parent(Specialisation)\" underneath.",
      defaultValue: "",
    },
    {
      header: "Short name",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Online MCA",
      defaultValue: "",
    },
    {
      header: "Full name",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Master of Computer Applications",
      defaultValue: "",
    },
    {
      header: "Card URL",
      fieldName: "meta_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/online-mca",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS_1: [],
};
